import { useState } from "react";
import { Link } from "react-router";
import { Aviso, Botao, Cartao, Chip } from "../ui";
import { mensagemDoConsole } from "../../nucleo/console";
import {
  CHIP_DO_ESTADO,
  ROTULO_DO_ESTADO,
  corpoDaCriacao,
  dataHoraLegivel,
  formularioEmBranco,
  useCompromissos,
  useCriarCompromisso,
} from "../../nucleo/compromissos";
import { podeNaSessao, useSessao } from "../../nucleo/sessao";
import { FormularioDeCompromisso } from "./FormularioDeCompromisso";

/**
 * Os compromissos da equipe ligados a este chamado, e o atalho para agendar mais um. Só aparece
 * na tela da equipe, e só para quem tem `compromisso:gerenciar`: o cliente nunca vê a agenda.
 */
export function CompromissosDoChamado({
  ticketId,
  numero,
}: {
  ticketId: string;
  numero: number;
}) {
  const sessao = useSessao();
  const pode = podeNaSessao(sessao.data, "compromisso:gerenciar");
  const lista = useCompromissos({ ticketId }, pode);
  const criar = useCriarCompromisso();
  const [agendando, setAgendando] = useState(false);

  if (!pode) return null;

  return (
    <Cartao titulo="Compromissos" data-testid="compromissos-do-chamado" className="mb-4">
      {lista.isPending ? <p role="status">Carregando compromissos…</p> : null}
      {lista.isError ? <Aviso tom="erro">{mensagemDoConsole(lista.error)}</Aviso> : null}
      {lista.data && lista.data.length === 0 && !agendando ? (
        <p>Nenhum compromisso ligado a este chamado.</p>
      ) : null}
      {lista.data && lista.data.length > 0 ? (
        <ul>
          {lista.data.map((item) => (
            <li key={item.id} data-testid={`compromisso-do-chamado-${item.titulo}`}>
              <Chip estado={CHIP_DO_ESTADO[item.estado]}>{ROTULO_DO_ESTADO[item.estado]}</Chip>{" "}
              <b>{item.titulo}</b>{" "}
              <span className="celula-secundaria">
                {dataHoraLegivel(item.inicio_em)} · {item.responsavel.nome}
              </span>
            </li>
          ))}
        </ul>
      ) : null}
      {agendando ? (
        <FormularioDeCompromisso
          inicial={formularioEmBranco()}
          editando={false}
          vinculoFixo={{ ticketNumero: numero }}
          enviando={criar.isPending}
          erroDoServidor={criar.error}
          aoCancelar={() => setAgendando(false)}
          aoEnviar={(form) =>
            criar.mutate(
              corpoDaCriacao({ ...form, organizacaoId: "", ticketNumero: String(numero), ativoId: "" }),
              { onSuccess: () => setAgendando(false) },
            )
          }
        />
      ) : (
        <div className="mt-2 flex items-center gap-3">
          <Botao tamanho="pequeno" variante="fantasma" onClick={() => setAgendando(true)} data-testid="agendar-no-chamado">
            Agendar compromisso
          </Botao>
          <Link to="/admin/compromissos">Abrir a agenda</Link>
        </div>
      )}
    </Cartao>
  );
}
